<template>
  <div class="support" @mouseenter="open = true" @mouseleave="open = false">
    <transition name="pop">
      <div v-show="open" class="support-pop">
        <img src="@/assets/img/lxwm.png" alt="在线客服二维码" />
        <p>扫码联系在线客服</p>
      </div>
    </transition>

    <button class="support-btn" :class="{ 'is-open': open }" @click="open = !open" aria-label="在线客服">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8z" />
      </svg>
    </button>
  </div>
</template>

<script>
export default {
  name: "SupportFab",
  data() {
    return { open: false };
  }
};
</script>

<style scoped>
.support {
  position: fixed;
  right: 22px;
  bottom: 28px;
  z-index: 1500;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 12px;
}

.support-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #fff;
  color: var(--text-1);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-md);
  transition: transform 0.2s ease, box-shadow 0.2s ease, background 0.2s ease,
    color 0.2s ease;
}

.support-btn svg {
  width: 22px;
  height: 22px;
}

.support-btn:hover,
.support-btn.is-open {
  background: var(--ink);
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 14px 32px rgba(17, 24, 39, 0.24);
}

.support-pop {
  padding: 12px;
  background: #fff;
  border: 1px solid var(--border);
  border-radius: var(--r-lg);
  box-shadow: var(--shadow-lg);
  text-align: center;
}

.support-pop img {
  width: 168px;
  height: 168px;
  object-fit: contain;
  border-radius: var(--r-md);
}

.support-pop p {
  margin-top: 8px;
  color: var(--text-2);
  font-size: 12.5px;
}

.pop-enter-active,
.pop-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.pop-enter-from,
.pop-leave-to {
  opacity: 0;
  transform: translateY(8px) scale(0.96);
}

@media (max-width: 640px) {
  .support {
    right: 14px;
    bottom: 18px;
  }
  .support-btn {
    width: 44px;
    height: 44px;
  }
  .support-pop img {
    width: 140px;
    height: 140px;
  }
}
</style>
